<template>
  <ResearchGalleryPage
    page-title="集体过生日"
    section-label="科研保障"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuJitiguoshengri',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_keyanbaozhang',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '离退休人员集体过生日',
          kicker: '1989-2016',
          items: [
            {
              src: require('./assets/html/birthday-1989.jpg'),
              caption: '1989 年 12 月，新闻与传播研究所为逢五逢十的离退休新老寿星集体过生日'
            },
            {
              src: require('./assets/html/birthday-2004.jpg'),
              caption: '2004 年 12 月，新闻与传播研究所为逢五逢十的离退休新老寿星集体过生日'
            },
            {
              src: require('./assets/html/birthday-2013.jpg'),
              caption: '2013 年 12 月，新闻与传播研究所离退休人员集体过生日'
            },
            {
              src: require('./assets/html/birthday-2014.jpg'),
              caption: '2014 年 12 月，新闻与传播研究所离退休人员集体过生日'
            },
            {
              src: require('./assets/html/birthday-2015.jpg'),
              caption: '2015 年 12 月，新闻与传播研究所离退休人员集体过生日'
            },
            {
              src: require('./assets/html/birthday-2016.jpg'),
              caption: '2016 年 12 月，新闻与传播研究所离退休人员集体过生日'
            }
          ]
        }
      ]
    };
  }
};
</script>
